import { Form } from 'antd';
import { FormProps } from 'antd/lib/form';

export type FormAtomProps = FormProps;

const FormAtom = Form;

export default FormAtom;
